
export default {
    name: 'AutoQuoteBanner',
    props: {
        business: {
            type: Object,
            required: true,
        },
    },
    computed: {
        link() {
            return {
                text: this.$t('common.setup'),
                to: { name: 'business-slug-edit', params: { business: this.business }, query: { step: 'auto' } },
            };
        },
    },
};

